"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var open_tab_1 = require("./open-tab");
var DEFAULT_POPUP_PARAMS = {
    toolbar: false,
    location: false,
    directories: false,
    status: false,
    menubar: false,
    scrollbars: true,
    resizable: true,
    copyhistory: false,
};
function openPopup(url, width, height, onClose) {
    if (width === void 0) { width = 980; }
    if (height === void 0) { height = 600; }
    var left = (window.screen.width - width) / 2;
    var top = (window.screen.height - height) / 2;
    var params = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_POPUP_PARAMS), { width: width, height: height, top: top, left: left });
    (0, open_tab_1.openTab)(url, params, '_blank', onClose);
}
exports.default = openPopup;
//# sourceMappingURL=open-popup.js.map